import { lazy } from 'react';
import { RouteObject } from 'react-router';

import {
  HomeRoute,
  SearchRoute,
  DetailRoute,
  AgreementRoute,
  ExporterRoute,
  ProductSearchRoute,
  AboutRoute,
  PreferentialTreatmentRoute,
  LoginRoute,
  PrivacyPolicyRoute,
  KeynotesRoute,
  RegisterRoute,
  DisclaimerRoute,
  TermsOfUseRoute,
  RulesOfOriginRoute,
  NewsDetailRoute,
  TradeDetailRoute,
  BasicInformationRoute,
  UserGuideRoute,
  HelpDeskRulesOfOriginRoute,
  CambodiaCustomGuidesRoute,
  SiteGlossaryRoute,
  FaqRoute,
  HelpDeskRoute,
  LanguageSlugRoute,
  ResetPasswordRoute,
  RequestResetPasswordRoute,
} from 'routes/route';

const Home = lazy(() => import('../pages/home'));
const Keynotes = lazy(() => import('../pages/keynotes'));
const Search = lazy(() => import('../pages/search'));
const Detail = lazy(() => import('../pages/detail'));
const Agreement = lazy(() => import('../pages/agreements'));
const NewsDetail = lazy(() => import('../pages/news-detail'));
const Exporter = lazy(() => import('../pages/exporter'));
const ProductSearch = lazy(() => import('../pages/product-search'));
const About = lazy(() => import('../pages/about'));
const RulesOfOrigin = lazy(() => import('../pages/rules-of-origin'));
const PreferentialTreatment = lazy(() => import('../pages/preferential-treatment'));
const Login = lazy(() => import('../pages/login'));
const Register = lazy(() => import('../pages/register'));
const PrivacyPolicy = lazy(() => import('../pages/privacy-policy'));
const TermsOfUse = lazy(() => import('../pages/terms-of-use'));
const Disclaimer = lazy(() => import('../pages/disclaimer'));
const FAQ = lazy(() => import('../pages/help-desk/faq'));
const BasicInformation = lazy(() => import('../pages/help-desk/basic-information'));
const UserGuide = lazy(() => import('../pages/help-desk/user-guide'));
const SiteGlossary = lazy(() => import('../pages/help-desk/site-glossary'));
const CambodiaCustomGuides = lazy(() => import('../pages/help-desk/cambodia-custom-guides'));
const HelpDeskRulesOfOrigin = lazy(() => import('../pages/help-desk/rules-of-origin'));
const TradeDetail = lazy(() => import('../pages/trade-detail'));
const HelpDesk = lazy(() => import('../pages/help-desk'));
const ResetPassword = lazy(() => import('../pages/reset-password'));
const RequestResetPassword = lazy(() => import('../pages/request-reset-password'));

const PublicRoutes: RouteObject = {
  path: LanguageSlugRoute + '',
  children: [
    {
      path: LanguageSlugRoute + HomeRoute,
      element: <Home />,
    },
    {
      path: LanguageSlugRoute + SearchRoute,
      element: <Search />,
    },
    {
      path: LanguageSlugRoute + `${DetailRoute}/:id`,
      element: <Detail />,
    },
    {
      path: LanguageSlugRoute + KeynotesRoute,
      element: <Keynotes />,
    },
    {
      path: LanguageSlugRoute + AgreementRoute,
      element: <Agreement />,
    },
    {
      path: LanguageSlugRoute + ExporterRoute,
      element: <Exporter />,
    },
    {
      path: LanguageSlugRoute + ProductSearchRoute,
      element: <ProductSearch />,
    },
    {
      path: LanguageSlugRoute + HelpDeskRoute,
      element: <HelpDesk />,
    },
    {
      path: LanguageSlugRoute + UserGuideRoute,
      element: <UserGuide />,
    },
    {
      path: LanguageSlugRoute + BasicInformationRoute,
      element: <BasicInformation />,
    },
    {
      path: LanguageSlugRoute + HelpDeskRulesOfOriginRoute,
      element: <HelpDeskRulesOfOrigin />,
    },
    {
      path: LanguageSlugRoute + CambodiaCustomGuidesRoute,
      element: <CambodiaCustomGuides />,
    },
    {
      path: LanguageSlugRoute + SiteGlossaryRoute,
      element: <SiteGlossary />,
    },
    {
      path: LanguageSlugRoute + FaqRoute,
      element: <FAQ />,
    },
    {
      path: LanguageSlugRoute + AboutRoute,
      element: <About />,
    },
    {
      path: LanguageSlugRoute + `${RulesOfOriginRoute}/:id`,
      element: <RulesOfOrigin />,
    },
    {
      path: LanguageSlugRoute + PreferentialTreatmentRoute,
      element: <PreferentialTreatment />,
    },
    {
      path: LanguageSlugRoute + LoginRoute,
      element: <Login />,
    },
    {
      path: LanguageSlugRoute + RegisterRoute,
      element: <Register />,
    },
    {
      path: LanguageSlugRoute + PrivacyPolicyRoute,
      element: <PrivacyPolicy />,
    },
    {
      path: LanguageSlugRoute + TermsOfUseRoute,
      element: <TermsOfUse />,
    },
    {
      path: LanguageSlugRoute + DisclaimerRoute,
      element: <Disclaimer />,
    },
    {
      path: LanguageSlugRoute + `${NewsDetailRoute}/:id`,
      element: <NewsDetail />,
    },
    {
      path: LanguageSlugRoute + `${TradeDetailRoute}/:id`,
      element: <TradeDetail />,
    },
    {
      path: LanguageSlugRoute + `${ResetPasswordRoute}`,
      element: <ResetPassword />,
    },
    {
      path: LanguageSlugRoute + `${RequestResetPasswordRoute}`,
      element: <RequestResetPassword />,
    },
  ],
};

export default PublicRoutes;
